import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`text-sm select-none`};
  font-family: var(--font-gotham);
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0.15em;

  ${tw`flex space-x-3 justify-center`};
`

const NavLink = styled.a`
  ${tw`relative flex items-center justify-center cursor-pointer`};
  min-width: 40px;
  min-height: 40px;
  color: var(--color-gold);
`

export const PrevLink = styled(NavLink)``

export const NextLink = styled(NavLink)``

export const ViewAllLink = styled(NavLink)`
  ${tw`text-sm select-none`};
  font-family: var(--font-gotham);
  font-weight: normal;
  text-transform: uppercase;
  letter-spacing: 0.15em;
`

export const PageLink = styled.a`
  ${tw`relative flex items-center justify-center cursor-pointer`};
  min-width: 40px;
  min-height: 40px;
  color: var(--color-gold);
  border: solid 1px transparent;

  &:hover,
  &:focus {
    border-color: var(--color-gold-light);
  }

  ${({ $isCurrent }) =>
    $isCurrent && {
      color: 'var(--color-white)',
      backgroundColor: 'var(--color-gold-light)',
    }};
`
